import type { NfDatasourceRegistry } from '../nf-datasource.service';
import { coulsonDatasource } from './coulson.datasource';
import { furyDatasource } from './fury.datasource';

export { provideToolbeltServices } from './toolbelt-native-services.provider';

/**
 * Every backend registered for our custom `x-datasource` CRUD extension, keyed by service name
 * (the value schemas put in `x-datasource.service`). Passed straight to provideNfDatasources()
 * in app.config.ts.
 *
 * Backends usable by @mercadoni/toolbelt's own remote-select/file-upload widgets are a
 * *separate* registration — see provideToolbeltServices() in toolbelt-native-services.provider.ts.
 *
 * To integrate a new backend: add `<name>.datasource.ts` in this folder exporting an
 * `NfDatasourceRegistry` entry (same shape as coulsonDatasource), spread it in here, and add it
 * to provideToolbeltServices() too if any schema needs it for a native remote-select/file-upload.
 */
export const TOOLBELT_DATASOURCES: NfDatasourceRegistry = {
  ...coulsonDatasource,
  ...furyDatasource,
};
